// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1wnVY","balanceDisclaimer":"posDashboard_balanceDisclaimer__1yUd1"};